import React, { FC } from 'react'

import ImageTransport from '../../../transports/common/image-transport'
import { CarouselContainer, StyledSlider, StyledCarouselProvider } from './styles'
import { DotsContainer } from './dots-container'
import CarouselButtonNext from './carousel-button-next'
import CarouselButtonBack from './carousel-button-back'
import LazyCarouselSlides from './lazy-carousel-slides'

type Props = {
    images: ImageTransport[]
    imageCarouselBorderRadius?: string
    aspectRatio?: string
    horizontalCardHeight?: string
    imageCarouselMargin?: string
    isAboveFold?: boolean
    imwidth?: number
}

const ImageCarousel: FC<Props> = ({
    images,
    imageCarouselBorderRadius,
    aspectRatio,
    horizontalCardHeight,
    imageCarouselMargin,
    isAboveFold = false,
    imwidth,
}) => {
    return (
        <CarouselContainer
            horizontalCardHeight={horizontalCardHeight}
            imageCarouselBorderRadius={imageCarouselBorderRadius}
            margin={imageCarouselMargin}
        >
            <StyledCarouselProvider
                totalSlides={images.length}
                visibleSlides={1}
                naturalSlideWidth={1}
                naturalSlideHeight={1}
                isIntrinsicHeight
                lockOnWindowScroll
                dragStep={1}
                dragEnabled={images.length > 1}
                step={1}
                infinite
            >
                <CarouselButtonBack />
                <StyledSlider $transitionTime={0.01}>
                    <LazyCarouselSlides
                        images={images}
                        aspectRatio={aspectRatio}
                        horizontalCardHeight={horizontalCardHeight}
                        isAboveFold={isAboveFold}
                        imwidth={imwidth}
                    />
                </StyledSlider>
                {images.length > 1 && <DotsContainer borderRadius={'0.75rem'} numberOfDots={images.length} />}
                <CarouselButtonNext />
            </StyledCarouselProvider>
        </CarouselContainer>
    )
}

export default ImageCarousel
